/* eslint-disable sonarjs/no-nested-functions */
/* eslint-disable default-param-last */
/* eslint-disable sonarjs/default-param-last */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { hostname } from './util';

export const getProjects = (params) =>
  axios
    .get(
      `${hostname}/comms/projects?skip=${params?.skip || ''}&keywords=${params?.keywords || ''}&limit=${params?.limit || ''}`
    )
    .then((projectsRes) => ({
      projectItems: projectsRes.data.results,
      pTotal:
        projectsRes.data.total || projectsRes.data.count || projectsRes.data.results?.length || 0,
      unassignedCount: projectsRes.data.unassigned,
    }));

export const getProject = ({ id }) =>
  axios.get(`${hostname}/comms/projects/${id}`).then((resp) => resp.data);

export const getLocations = () =>
  axios.get(`${hostname}/api/portal/locations`).then((locationsRes) => ({
    locationsItems: locationsRes.data.results,
  }));

export const moveUsers = ({ userIds, projectId }) =>
  axios.post(`${hostname}/comms/projects/${projectId}/members`, { members: userIds });

export const removeUser = ({ projectId, memberId }) =>
  axios.delete(`${hostname}/comms/projects/${projectId}/members/${memberId}`);

export const getProjectUsers = (params) =>
  axios
    .get(
      params
        ? `${hostname}/comms/projects/users?skip=${params.skip}&keywords=${params.keywords}&project=${params.project}&unassigned=${params.unassigned}`
        : `${hostname}/comms/projects/users?limit=-1`
    )
    .then((usersRes) => ({
      usersItems: usersRes.data.results,
      uTotal: usersRes.data.total || usersRes.data.count || usersRes.data.results?.length || 0,
      uGrandTotal: usersRes.data.grandTotal,
    }));

export const createProject = (params) => axios.post(`${hostname}/comms/projects`, params);

export const updateProject = ({
  projectId,
  name,
  accentColour,
  situationalAwarenessEnabled,
  smartEnabled,
  categories,
}) =>
  axios.put(`${hostname}/comms/projects/${projectId}`, {
    name,
    accent_colour: accentColour,
    situational_awareness_enabled: situationalAwarenessEnabled,
    smart_enabled: smartEnabled,
    categories,
  });

export const deleteProject = ({ projectId }) =>
  axios.delete(`${hostname}/comms/projects/${projectId}/delete`);

// ===== Admin users

export const deleteUser = ({ memberId }) =>
  axios.delete(`${hostname}/api/portal/users/${memberId}`);

export const reinviteUser = ({ memberId }) =>
  axios.post(`${hostname}/api/portal/users/${memberId}/request-reinvite`);

export const createUser = (params) => axios.post(`${hostname}/api/portal/users`, params);

export const editUser = ({ memberId, ...params }) =>
  axios.post(`${hostname}/api/portal/users/${memberId}`, params);

export const getUsers = (params) =>
  axios
    .get(`${hostname}/api/portal/users?skip=${params.skip}&keywords=${params.keywords}`)
    .then((usersRes) => ({
      usersItems: usersRes.data.results,
      uTotal: usersRes.data.total || usersRes.data.count || usersRes.data.results?.length || 0,
    }));

export const getCustomers = () => axios.get(`${hostname}/comms/customers`);

// ====== LOGIN

export const resetPassword = ({ email }) =>
  axios.post(`${hostname}/api/portal/auth/request-reset-password`, { email });

export const resetUserPassword = ({ memberId }) =>
  axios.post(`${hostname}/api/portal/users/${memberId}/request-reset-password`);

export const createNewPassword = (params) =>
  axios.post(`${hostname}/api/portal/auth/reset-password`, params).catch((e) => {
    console.error('Failed to create new password', e?.response?.data?.error);
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(
      e?.response?.data?.suggestion || e?.response?.data?.error || 'Failed to create password'
    );
  });

export const onBoardUser = (params) =>
  axios.post(`${hostname}/api/portal/auth/onboard`, params).catch((e) => {
    console.error('Failed to onboard new user', e?.response?.data?.error);
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(
      e?.response?.data?.suggestion || e?.response?.data?.error || 'Failed to create password'
    );
  });

export default getProjects;
